import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import '../../../css/PreAdvise/CreatePreadvise.css';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import arrowUp from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class CreatePreadvise extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            EquipmentNo: '',
            GrossWeight: '',
            VGMWeight: '',
            bookingNo: '',
            AccreditationNo: '',
            SealNo1: '',
            EquipmentType: '',
            lineOperator: '',
            SealNo2: '',
            VGMVerifier: '',
            OrderItem: '',
            CarrierMode: '',
            MethodSelection: '',
            CarrierModedropdown: false,
            OrderItemdropdown: false,
            MethodSelectiondropdown: false,
            sealno1dropdown: false,
            lineoperatordropdown: false,
            vgmverifierdropdown: false,
            equipmenttypedropdown: false,
            sealno2dropdown: false,
            CarrierModedata: [],
            OrderItemdata: [],
            MethodSelectiondata: [],
            SelectTerminal: '',
            containerID: '',
            vesselVisit: '',
            terminalDropdown: false,
            appointmentdropdown: false,
            terminal: [],
            appointment: [],
            lineoperatordata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchlinelength: 0,
            lineoperatordata1: [],
            sealno1data: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchsealno1length: 0,
            sealno1data1: [],
            vgmverifierdata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchvgmverifierlength: 0,
            vgmverifierdata1: [],
            equipmenttypedata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchequipmenttypelength: 0,
            equipmenttypedata1: [],
            sealno2data: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchsealno2length: 0,
            sealno2data1: [],
            calender: new Date(),
            showCalender: false,
            errors: {}
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleChangeSealNo1 = this.handleChangeSealNo1.bind(this);
        this.handleChangeLineOperator = this.handleChangeLineOperator.bind(this);
        this.handleChangeVGMVerifier = this.handleChangeVGMVerifier.bind(this);
        this.handleChangeEquipmentType = this.handleChangeEquipmentType.bind(this);
        this.handleChangeSealNo2 = this.handleChangeSealNo2.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    OnValidated = () => {
        this.props.history.push("/CreatePreadviseDetails");
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ terminalDropdown: false });
            this.setState({ CarrierModedropdown: false });
            this.setState({ OrderItemdropdown: false });
            this.setState({ MethodSelectiondropdown: false });
            this.setState({ showCalender: false });
            this.setState({ appointmentdropdown: false });
            this.setState({ sealno1dropdown: false });
            this.setState({ lineoperatordropdown: false });
            this.setState({ vgmverifierdropdown: false });
            this.setState({ equipmenttypedropdown: false });
            this.setState({ sealno2dropdown: false });
        }
    };
    terminaldata = [
        { id: 1, terminal: "Cape Town Container Terminal", triptype: "Transhipment" },
        { id: 2, terminal: "Durban Pier One Container Terminal", triptype: "Export" },
        { id: 3, terminal: "Durban Pier One Container Terminal", triptype: "Import" }]
    terminal = [{ terminalname: "xyz" }, { terminalname: "xyz" }, { terminalname: "xyz" }]
    CarrierModedata = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    OrderItemdata = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    MethodSelectiondata = [{ name: "SM1" }, { name: "SM2" }, { name: "SM3" }]
    handleSubmit = () => {
        if (this.handleValidation()) {
            this.OnValidated();
        }
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.SelectTerminal) {
            formIsValid = false;
            errors["selectTerminal"] = Message.validation.required;
            document.getElementsByName('SelectTerminal')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SelectTerminal')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.EquipmentNo) {
            formIsValid = false;
            errors["equipmentNo"] = Message.validation.required;
            document.getElementsByName('EquipmentNo')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('EquipmentNo')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.GrossWeight) {
            formIsValid = false;
            errors["grossWeight"] = Message.validation.required;
            document.getElementsByName('GrossWeight')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('GrossWeight')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.VGMWeight) {
            formIsValid = false;
            errors["VGMWeight"] = Message.validation.required;
            document.getElementsByName('VGMWeight')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('VGMWeight')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.bookingNo) {
            formIsValid = false;
            errors["bookingNo"] = Message.validation.required;
            document.getElementsByName('bookingNo')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('bookingNo')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.OrderItem) {
            formIsValid = false;
            errors["orderItem"] = Message.validation.required;
            document.getElementsByName('OrderItem')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('OrderItem')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.CarrierMode) {
            formIsValid = false;
            errors["carrierMode"] = Message.validation.required;
            document.getElementsByName('CarrierMode')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('CarrierMode')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.SealNo1) {
            formIsValid = false;
            errors["sealNo1"] = Message.validation.required;
            document.getElementsByName('SealNo1')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SealNo1')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.EquipmentType) {
            formIsValid = false;
            errors["equipmentType"] = Message.validation.required;
            document.getElementsByName('EquipmentType')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('EquipmentType')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.lineOperator) {
            formIsValid = false;
            errors["lineOperator"] = Message.validation.required;
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.VGMVerifier) {
            formIsValid = false;
            errors["VGMVerifier"] = Message.validation.required;
            document.getElementsByName('VGMVerifier')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('VGMVerifier')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.MethodSelection) {
            formIsValid = false;
            errors["methodSelection"] = Message.validation.required;
            document.getElementsByName('MethodSelection')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('MethodSelection')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (this.state.MethodSelection != "SM1") {
            if (!this.state.AccreditationNo) {
                formIsValid = false;
                errors["accreditationNo"] = Message.validation.required;
                document.getElementsByName('AccreditationNo')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('AccreditationNo')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    toggleDropdownTerminal = () => {
        this.setState({ terminalDropdown: !this.state.terminalDropdown });
    };
    changeRoleTypeTerminal = (event) => {
        const found = this.terminal?.find((name) => {
            if (name?.terminalname === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ SelectTerminal: found.terminalname });
        this.setState({ terminalDropdown: !this.state.terminalDropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                selectTerminal: ''
            }
        });
        document.getElementsByName('SelectTerminal')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleDropdownCarrierMode = () => {
        this.setState({ CarrierModedropdown: !this.state.CarrierModedropdown });
        console.log('vvv')
    };
    changeRoleTypeCarrierMode = (event) => {
        const found = this.CarrierModedata?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ CarrierMode: found.name });
        this.setState({ CarrierModedropdown: !this.state.CarrierModedropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                carrierMode: ''
            }
        });
        document.getElementsByName('CarrierMode')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleDropdownOrderItem = () => {
        this.setState({ OrderItemdropdown: !this.state.OrderItemdropdown });
        console.log('vvv')
    };
    changeRoleTypeOrderItem = (event) => {
        const found = this.OrderItemdata?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ OrderItem: found.name });
        this.setState({ OrderItemdropdown: !this.state.OrderItemdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                orderItem: ''
            }
        });
        document.getElementsByName('OrderItem')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleDropdownMethodSelection = () => {
        this.setState({ MethodSelectiondropdown: !this.state.MethodSelectiondropdown });
        console.log('vvv')
    };
    changeRoleTypeMethodSelection = (event) => {
        const found = this.MethodSelectiondata?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ MethodSelection: found.name });
        this.setState({ MethodSelectiondropdown: !this.state.MethodSelectiondropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                methodSelection: ''
            }
        });
        document.getElementsByName('MethodSelection')[0].style.borderColor = ColorCode.colorCode.black;
        if (found.name == "SM1") {
            this.setState({
                errors: {
                    ...this.state.errors,
                    methodSelection: '',
                    accreditationNo: ''
                }
            });
            document.getElementsByName('AccreditationNo')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    handleChangeEquipmentNo = (e) => {
        this.setState({ EquipmentNo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                equipmentNo: ''
            }
        });
        document.getElementsByName('EquipmentNo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeGrossWeight = (e) => {
        this.setState({ GrossWeight: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                grossWeight: ''
            }
        });
        document.getElementsByName('GrossWeight')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeVGMWeight = (e) => {
        this.setState({ VGMWeight: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                VGMWeight: ''
            }
        });
        document.getElementsByName('VGMWeight')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeBookingNo = (e) => {
        this.setState({ bookingNo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                bookingNo: ''
            }
        });
        document.getElementsByName('bookingNo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeAccreditationNo = (e) => {
        this.setState({ AccreditationNo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                accreditationNo: ''
            }
        });
        document.getElementsByName('AccreditationNo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeSealNo1 = (e) => {
        this.setState({ SealNo1: e.target.value, searchsealno1length: e?.target?.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                sealNo1: ''
            }
        });
        document.getElementsByName('SealNo1')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeEquipmentType = (e) => {
        this.setState({ EquipmentType: e.target.value, searchequipmenttypelength: e?.target?.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                equipmentType: ''
            }
        });
        document.getElementsByName('EquipmentType')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeLineOperator = (e) => {
        this.setState({ lineOperator: e.target.value, searchlinelength: e?.target?.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                lineOperator: ''
            }
        });
        document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeSealNo2 = (e) => {
        this.setState({ SealNo2: e.target.value, searchsealno2length: e?.target?.value?.length });
    }
    handleChangeVGMVerifier = (e) => {
        this.setState({ VGMVerifier: e.target.value, searchvgmverifierlength: e?.target?.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                VGMVerifier: ''
            }
        });
        document.getElementsByName('VGMVerifier')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleSearchsealno1drop = (e) => {
        this.setState({ sealno1dropdown: true });
    };
    toggleSearchlineoperatordrop = (e) => {
        this.setState({ lineoperatordropdown: true });
    };
    toggleSearchvgmverifierdrop = (e) => {
        this.setState({ vgmverifierdropdown: true });
    };
    toggleSearchequipmenttypedrop = (e) => {
        this.setState({ equipmenttypedropdown: true });
    };
    toggleSearchsealno2drop = (e) => {
        this.setState({ sealno2dropdown: true });
    };
    changesealno1 = (event) => {
        const found = this.state.sealno1data1?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ SealNo1: found.name });
        this.setState({ sealno1dropdown: !this.state.sealno1dropdown });
    }
    changelineoperator = (event) => {
        const found = this.state.lineoperatordata1?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ lineOperator: found.name });
        this.setState({ lineoperatordropdown: !this.state.lineoperatordropdown });
    }
    changevgmverifier = (event) => {
        const found = this.state.vgmverifierdata1?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ VGMVerifier: found.name });
        this.setState({ vgmverifierdropdown: !this.state.vgmverifierdropdown });
    }
    changeequipmenttype = (event) => {
        const found = this.state.equipmenttypedata1?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ EquipmentType: found.name });
        this.setState({ equipmenttypedropdown: !this.state.equipmenttypedropdown });
    }
    changesealno2 = (event) => {
        const found = this.state.sealno2data1?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ SealNo2: found.name });
        this.setState({ sealno2dropdown: !this.state.sealno2dropdown });
    }
    render() {
        if (this.state.searchsealno1length > 0) {
            this.state.sealno1data1 = this.state.sealno1data?.filter(i => i?.name?.startsWith(this.state.SealNo1?.toLowerCase()))
        } else {
            this.state.sealno1data1 = [];
        }
        if (this.state.searchlinelength > 0) {
            this.state.lineoperatordata1 = this.state.lineoperatordata?.filter(i => i?.name?.startsWith(this.state.lineOperator?.toLowerCase()))
            console.log("line", this.state.lineoperatordata1);
        } else {
            console.log("else", this.state.lineoperatordata1);
            this.state.lineoperatordata1 = [];
        }
        if (this.state.searchvgmverifierlength > 0) {
            this.state.vgmverifierdata1 = this.state.vgmverifierdata?.filter(i => i?.name?.startsWith(this.state.VGMVerifier?.toLowerCase()))
        } else {
            this.state.vgmverifierdata1 = [];
        }
        if (this.state.searchequipmenttypelength > 0) {
            this.state.equipmenttypedata1 = this.state.equipmenttypedata?.filter(i => i?.name?.startsWith(this.state.EquipmentType?.toLowerCase()))
        } else {
            this.state.equipmenttypedata1 = [];
        }
        if (this.state.searchsealno2length > 0) {
            this.state.sealno2data1 = this.state.sealno2data?.filter(i => i?.name?.startsWith(this.state.SealNo2?.toLowerCase()))
        } else {
            this.state.sealno2data1 = [];
        }
        let terminalDropdownImage = this.state.terminalDropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let CarrierModedropdownImage = this.state.CarrierModedropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let OrderItemdropdownImage = this.state.OrderItemdropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let MethodSelectiondropdownImage = this.state.MethodSelectiondropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.createPreAdvisePageTitle} description={TitleDescription.createPreAdvisePageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofull">
                    <div id="caacsnobox1">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarnameCreatePre">
                                <small id="nonavc">Pre-advise for Single Container</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="caanotificationmaincardCreateP">
                            <div class="caaoncsdivlow1">
                                <div class="adscsdivlow2">
                                    Site Selection</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup2CreatePre">
                                    <div class="caadivup3CreatePre">
                                        <small id="caaname">Terminal</small>
                                        <div className="pass-wrapper" id="caad07" >
                                            <Input
                                                name="SelectTerminal"
                                                readOnly class="input" value={this.state.SelectTerminal} placeholder="Select Terminal"
                                                type="text" id="caad066"
                                            />
                                            <div className="createpreadviseerror11">{this.state.errors["selectTerminal"]}</div>
                                            <i id="caainput_imgAddProfile" onClick={this.toggleDropdownTerminal}>{terminalDropdownImage}</i>
                                        </div>
                                        {this.state.terminalDropdown && (
                                            <div class="caaad08" >
                                                <div class="caadropdowncard" ref={this.container} >
                                                    {(this.terminal?.map((name, index) => {
                                                        return (
                                                            <DropDownTable onClick={(index1) => this.changeRoleTypeTerminal(index1)} >
                                                                <small class="pl-3" id="caatt2" >{name?.terminalname} </small>
                                                            </DropDownTable>
                                                        );
                                                    }))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div class="caaoncsdivlow122">
                                <div class="adscsdivlow2">
                                    Gate Processing</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup4">
                                    <div class="caadivup55">
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Equipment No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="EquipmentNo"
                                                    class="input" placeholder="Enter Equipment No."
                                                    type="text" id="caad06" value={this.state.EquipmentNo}
                                                    onChange={this.handleChangeEquipmentNo}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["equipmentNo"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Gross Weight (kg)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="GrossWeight"
                                                    class="input" placeholder="Enter Gross Weight"
                                                    type="text" id="caad06" value={this.state.GrossWeight}
                                                    onChange={this.handleChangeGrossWeight}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["grossWeight"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">VGM Weight (kg)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="VGMWeight"
                                                    class="input" placeholder="Enter VGM Weight"
                                                    type="text" id="caad06" value={this.state.VGMWeight}
                                                    onChange={this.handleChangeVGMWeight}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["VGMWeight"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Booking No.</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="bookingNo"
                                                    class="input" placeholder="Enter Booking No."
                                                    type="text" id="caad06" value={this.state.bookingNo}
                                                    onChange={this.handleChangeBookingNo}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["bookingNo"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Order Item</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="OrderItem"
                                                    readOnly class="input" placeholder="Select Order Item"
                                                    type="text" id="caad066" value={this.state.OrderItem}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["orderItem"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownOrderItem}>{OrderItemdropdownImage}</i>
                                            </div>
                                            {this.state.OrderItemdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.OrderItemdata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeOrderItem(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Carrier Mode</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="CarrierMode"
                                                    readOnly class="input" placeholder="Select Carrier Mode"
                                                    type="text" id="caad066" value={this.state.CarrierMode}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["carrierMode"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownCarrierMode}>{CarrierModedropdownImage}</i>
                                            </div>
                                            {this.state.CarrierModedropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.CarrierModedata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeCarrierMode(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Seal No 1</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="SealNo1"
                                                    class="input" placeholder="Enter Seal No 1"
                                                    type="text" id="caad06" value={this.state.SealNo1}
                                                    onChange={this.handleChangeSealNo1}
                                                    onKeyPress={this.toggleSearchsealno1drop}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["sealNo1"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.sealno1dropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.sealno1data1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changesealno1(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Equipment Type</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="EquipmentType"
                                                    class="input" placeholder="Enter Equipment Type"
                                                    type="text" id="caad06" value={this.state.EquipmentType}
                                                    onChange={this.handleChangeEquipmentType}
                                                    onKeyPress={this.toggleSearchequipmenttypedrop}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["equipmentType"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.equipmenttypedropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.equipmenttypedata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeequipmenttype(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Line Operator</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="lineOperator"
                                                    class="input" placeholder="Enter Line Operator"
                                                    type="text" id="caad06" value={this.state.lineOperator}
                                                    onChange={this.handleChangeLineOperator}
                                                    onKeyPress={this.toggleSearchlineoperatordrop}
                                                />
                                                <div className="createpreadviseerror11proxy">{this.state.errors["lineOperator"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.lineoperatordropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.lineoperatordata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changelineoperator(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreatePreproxy">
                                            <small id="caaname">Seal No 2 (Optional)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Seal No 2"
                                                    type="text" id="caad06" value={this.state.SealNo2}
                                                    onChange={this.handleChangeSealNo2}
                                                    onKeyPress={this.toggleSearchsealno2drop}
                                                />
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.sealno2dropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.sealno2data1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changesealno2(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="proxycaadivup5cp">
                                        <div class="caadivup3CreatePre">
                                            <div class="proxydiv">
                                                <div class="proxydivin">
                                                    <small class="proxydivtext">Only those shipping lines will be visible for which proxy is approved by admin. You can submit your proxy </small>
                                                    <small class="proxydivtextred"> here</small>
                                                    <img
                                                        src={rightarrow}
                                                        class="" id="proxytextimgred"
                                                        alt="" loading="lazy"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">VGM Verifier</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="VGMVerifier"
                                                    class="input" placeholder="Enter VGM Verifier"
                                                    type="text" id="caad06" value={this.state.VGMVerifier}
                                                    onChange={this.handleChangeVGMVerifier}
                                                    onKeyPress={this.toggleSearchvgmverifierdrop}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["VGMVerifier"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.vgmverifierdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.vgmverifierdata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changevgmverifier(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreatePre">
                                            <small id="caaname">Method Selection</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="MethodSelection"
                                                    readOnly class="input" placeholder="Select Method Selection"
                                                    type="text" id="caad066" value={this.state.MethodSelection}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["methodSelection"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownMethodSelection}>{MethodSelectiondropdownImage}</i>
                                            </div>
                                            {this.state.MethodSelectiondropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.MethodSelectiondata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeMethodSelection(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreatePre">
                                            <small id="caanameoptionout">
                                                <small id="caaname">Accreditation No.</small>
                                                <small id="caanameoption"> (Optional if 'Method Selection' is SM1)</small>
                                            </small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="AccreditationNo"
                                                    class="input" placeholder="Enter Accreditation No."
                                                    type="text" id="caad06" value={this.state.AccreditationNo}
                                                    onChange={this.handleChangeAccreditationNo}
                                                />
                                                <div className="createpreadviseerror11">{this.state.errors["accreditationNo"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caabuttdivCreatePre">
                                <Button class="caabuttdivCreatePre1" onClick={this.handleSubmit}>
                                    <small class="caabuttdivCreatePre2">Continue</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01cpreadvise">
                    <Footer />
                </div>
                <div class="caanotifooter02cpreadvise">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default CreatePreadvise;